export default __webpack_public_path__ + "static/imgTyrepng-61aa8d64d3c2b7b41c4c1d4c25e61b7e.png";